import assign from 'lodash/assign';
import assignIn from 'lodash/assignIn';
import cloneDeep from 'lodash/cloneDeep';
import concat from 'lodash/concat';
import countBy from 'lodash/countBy';
import each from 'lodash/each';
import filter from 'lodash/filter';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import forEachRight from 'lodash/forEachRight';
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';
import has from 'lodash/has';
import head from 'lodash/head';
import includes from 'lodash/includes';
import indexOf from 'lodash/indexOf';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isInteger from 'lodash/isInteger';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import keyBy from 'lodash/keyBy';
import keys from 'lodash/keys';
import last from 'lodash/last';
import lowerCase from 'lodash/lowerCase';
import lowerFirst from 'lodash/lowerFirst';
import map from 'lodash/map';
import mapKeys from 'lodash/mapKeys';
import max from 'lodash/max';
import merge from 'lodash/merge';
import min from 'lodash/min';
import orderBy from 'lodash/orderBy';
import padStart from 'lodash/padStart';
import reject from 'lodash/reject';
import remove from 'lodash/remove';
import replace from 'lodash/replace';
import reverse from 'lodash/reverse';
import set from 'lodash/set';
import shuffle from 'lodash/shuffle';
import size from 'lodash/size';
import slice from 'lodash/slice';
import some from 'lodash/some';
import sortBy from 'lodash/sortBy';
import split from 'lodash/split';
import sumBy from 'lodash/sumBy';
import take from 'lodash/take';
import toNumber from 'lodash/toNumber';
import uniqBy from 'lodash/uniqBy';
import upperCase from 'lodash/upperCase';
import upperFirst from 'lodash/upperFirst';
import values from 'lodash/values';

export default {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$lodash', {
      get() {
        return {
          assign,
          assignIn,
          cloneDeep,
          concat,
          countBy,
          each,
          filter,
          find,
          findIndex,
          forEachRight,
          get,
          groupBy,
          has,
          head,
          includes,
          indexOf,
          isArray,
          isEmpty,
          isEqual,
          isInteger,
          isNumber,
          isObject,
          isString,
          keyBy,
          keys,
          last,
          lowerCase,
          lowerFirst,
          map,
          mapKeys,
          max,
          merge,
          min,
          orderBy,
          padStart,
          reject,
          remove,
          replace,
          reverse,
          set,
          shuffle,
          size,
          slice,
          some,
          sortBy,
          split,
          sumBy,
          take,
          toNumber,
          uniqBy,
          upperCase,
          upperFirst,
          values,
        };
      },
    });
  },
};
